import * as React from 'react';
import { Layouts, NewbuildingLayoutsContext } from '@cian/frontend-newbuilding-layouts-widget';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';

import { selectHouseId } from '../../actions/offers';
import { AgentsOffersRow } from '../../components/AgentsOffersRow';
import { getGaLabel } from '../../selectors/analytics';
import { getHouseHasLayouts, getNewbuildingId } from '../../selectors/newbuilding';
import { getSelectedHouseId, getLayoutsRoomsCountsByHouse, getOffers } from '../../selectors/offers';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { BuilderOffersNotAvailable } from '../BuilderOffersNotAvailable';
import { CallButton } from '../CallButton';
import { trackShowPhoneInLayoutsClick } from '../PromosSection/tracking';

export const LayoutsContainer = () => {
  const dispatch = useDispatch();

  const selectedHouseId = useSelector(getSelectedHouseId);
  const newbuildingId = useSelector(getNewbuildingId);
  const roomsCountList = useSelector(getLayoutsRoomsCountsByHouse);
  const isHouseLayoutsAvailable = useSelector(getHouseHasLayouts);
  const offers = useSelector(getOffers);
  const gaLabel = useSelector(getGaLabel);

  const { httpApi, logger } = useApplicationContext();

  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  /* istanbul ignore next */
  const onHouseFilterReset = React.useCallback(() => {
    dispatch(selectHouseId(undefined));
  }, []);

  const trackShowPhone = React.useCallback(() => {
    trackShowPhoneInLayoutsClick(gaLabel);
  }, [gaLabel]);

  /* istanbul ignore next */
  if (offers.fromDeveloperRooms.length === 0) {
    return (
      <>
        <BuilderOffersNotAvailable />
        <AgentsOffersRow
          fromAgentsPropsCountDisplay={offers.fromAgentsPropsCountDisplay}
          fromAgentsPropsCountUrl={offers.fromAgentsPropsCountUrl}
        />
      </>
    );
  }

  return (
    <div data-testid="offers-layouts">
      <NewbuildingLayoutsContext.Provider value={contextValue}>
        <Layouts
          newbuildingId={newbuildingId}
          houseId={selectedHouseId}
          pageTypeJK="Featuring"
          isHouseLayoutsAvailable={isHouseLayoutsAvailable}
          roomsCountList={roomsCountList}
          onHouseFilterReset={onHouseFilterReset}
          contactsButton={
            <CallButton
              placeType="layouts"
              onShowPhoneClick={trackShowPhone}
              openContactsStyles={{ size: 'M' as const, theme: 'fill_secondary' }}
              showPhoneStyles={{
                size: 'M' as const,
                theme: 'fill_secondary',
                beforeIcon: <IconCommunicationPhone16 color="icon-main-default" />,
              }}
              SinglePhoneComponent={undefined}
              singlePhoneButtonText="Контакты застройщика"
            />
          }
        />
      </NewbuildingLayoutsContext.Provider>
    </div>
  );
};
